import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  Paper,
  Button,
  Snackbar,
  Alert,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  Backdrop,
  CircularProgress,
  Autocomplete
} from "@mui/material";
import { BsArrowRight } from "react-icons/bs";
import { vendorApi, investorApi } from "../../api/api"; // Assuming your API functions are in this file
import axios from 'axios';  // Import axios for API calls

const BannerDetails = () => {
  const [loading, setLoading] = useState(false); // Loader state
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Snackbar severity
  const [propertyType, setPropertyType] = useState("Individual"); // Default to "Individual"
  const [selectedImage, setSelectedImage] = useState(null); // Store file
  const [ImagePreview, setImagePreview] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);  // Store the selected project
  const [individualProjects, setIndividualProjects] = useState([]); // Store individual projects
  const [propertyErrors, setPropertyErrors] = useState({});
  const [rows, setRows] = React.useState([]); // Define the rows state

  const propertyTypeOptions = [
    { label: "Individual", value: "Individual" },
    { label: "Project", value: "Project" },
  ];

  const projectList = [
    { label: "Project1", value: "projct1" },
    { label: "Project2", value: "Project2" },
  ];

  // Fetch individual properties from the API
  useEffect(() => {
    if (propertyType === "Individual") {
    const getIndividualProperties = async () => {
      setLoading(true);  // Set loading to true initially
      try {
        const response = await investorApi.getIndividualProperties();

        // Check if the response data is an array
        if (Array.isArray(response.data)) {
          setIndividualProjects(response.data);  // Set data if it's an array
        } else {
          setIndividualProjects([]);  // Set an empty array if response is not as expected
        }
      } catch (error) {
        setIndividualProjects([]);  // If error, set empty array
      } finally {
        setLoading(false);  // Stop loading after the fetch attempt (whether successful or not)
      }
    };
    getIndividualProperties();
  }else {
    const getProjectData = async () => {
      setLoading(true);  // Set loading to true initially
      try {
        const response = await investorApi.getProjectNames();

        // Check if the response data is an array
        if (Array.isArray(response.data)) {
          setSelectedProject(response.data);  // Set data if it's an array
        } else {
          console.error('API response is not an array');
          setSelectedProject([]);  // Set an empty array if response is not as expected
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setSelectedProject([]);  // If error, set empty array
      } finally {
        setLoading(false);  // Stop loading after the fetch attempt (whether successful or not)
      }
    };
    getProjectData();
  }
}, []);



  const handleDisplayImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file); // Store the actual file for uploading
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSave = async(event) => {
    event.preventDefault();

    // Check if a project is selected based on the property type
    if (!selectedProject) {
      setSnackbarMessage("Please select a project.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    // Create a new FormData object to hold the form data
    const formData = new FormData();

    // Append the property type (as a string) to FormData
    formData.append("propertyType", propertyType);

    // Append the project name (or project ID) to FormData
    formData.append("projectName", selectedProject.name); // Assuming selectedProject has a name property

    // Append the selected image if available
    if (selectedImage) {
      formData.append("displayImage", selectedImage); // Add the file
    }

    for (let pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    // Example of how to send the form data to an API (using fetch or axios)
    setLoading(true); // Show loading indicator
    // You can use your API endpoint and send the data
    try {
        setSnackbarMessage("Project added successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        resetForm();
      } catch (error) {
        setSnackbarMessage("Failed to add project. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      } finally {
        setLoading(false);
      }
  };

  const handleChangePropertyType = (event) => {
    setPropertyType(event.target.value);
    setSelectedProject(null); // Clear selected project when property type changes
  };

  const resetForm = () => {
    setPropertyType("Individual");
    setPropertyErrors({});
  };

  return (
    <Container sx={{ py: 5, maxWidth: "80%" }}>
      {/* Loader */}
      <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ color: "#13216e", fontWeight: 600, fontSize: "24px" }}>
          Banner Details
        </Typography>
        <Box>
          <Link to="/banner" style={{ textDecoration: "none", color: "#4e0dff", fontSize: "18px" }}>
            Home
          </Link>
          <BsArrowRight style={{ margin: "-2px 8px", color: "#4e0dff" }} />
          <Link to="#" style={{ textDecoration: "none", color: "#4e0dff", fontSize: "18px" }}>
            Banner
          </Link>
        </Box>
      </Box>

      <Paper elevation={3} sx={{ padding: 3 }}>
        <form onSubmit={handleSave}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Property Type</InputLabel>
                <Select
                  value={propertyType}
                  onChange={handleChangePropertyType}
                  label="Property Type"
                >
                  {propertyTypeOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Display Project Dropdown if "Individual" is selected */}
          {propertyType === "Individual" && (
            <Grid item xs={12} style={{ marginTop: '20px' }}>
              <Autocomplete
                id="individual-projects"
                options={individualProjects}
                getOptionLabel={(option) => option.name}
                value={selectedProject}
                onChange={(event, newValue) => setSelectedProject(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Select Individual Project" variant="outlined" fullWidth />
                )}
              />
            </Grid>
          )}

          {/* Display Project Dropdown if "Project" is selected */}
          {propertyType === "Project" && (
            <Grid item xs={12} style={{ marginTop: '20px' }}>
              <Autocomplete
                id="projects"
                options={projectList}
                getOptionLabel={(option) => option.name}
                value={selectedProject}
                onChange={(event, newValue) => setSelectedProject(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Select Project" variant="outlined" fullWidth />
                )}
              />
            </Grid>
          )}

          {/* Display Image Section */}
          <Grid item xs={12} sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}>
              Display Picture
            </Typography>
            <label htmlFor="display-image-upload" style={{ cursor: "pointer", margin: "10px 15px" }}>
              <Button
                variant="outlined"
                color="primary"
                component="span"
                sx={{
                  borderColor: "primary.main",
                  color: "#fff",
                  backgroundColor: "#1565c0",
                  "&:hover": {
                    background: "#1565c0",
                    color: "rgba(25, 118, 210, 0.04)",
                    borderColor: "#1976d2",
                  },
                }}
              >
                Choose Display Image
              </Button>
            </label>
            <input
              id="display-image-upload"
              type="file"
              onChange={handleDisplayImageChange}
              style={{ display: "none" }}
            />
            {selectedImage && (
              <Box sx={{ mt: 2 }}>
                <img
                  src={ImagePreview}
                  alt="Display"
                  style={{
                    width: "20%",
                    height: "20%",
                    objectFit: "cover",
                    margin: 5,
                    borderRadius: 8,
                  }}
                />
              </Box>
            )}
          </Grid>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <Button variant="outlined" color="secondary" onClick={() => setPropertyErrors({})} sx={{ mr: 2 }}>
              Reset
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Save
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default BannerDetails;